import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export const NotesBox = ({ ...props }: NotesBoxProps): JSX.Element => {
    const [showDetails, setShowDetails] = useState(false);
    return (
        <div className="box is-shadowless mt-5">
            <div className="columns" onClick={() => setShowDetails(!showDetails)}>
                <div className="column is-half">
                    <h2 className="title is-6 has-text-ldark-gray">{props.title}</h2>
                </div>
                <div className="column is-half has-text-right">
                    {!showDetails && <FontAwesomeIcon icon={faPlus} size="sm" />}
                    {showDetails && <FontAwesomeIcon icon={faMinus} size="sm" />}
                </div>
            </div>
            {showDetails && <div>{props.children}</div>}
        </div>
    );
};

interface NotesBoxProps {
    title: string;
    children: React.ReactNode;
}
